import { getApi } from "./util/getApi";

const fetchURL = process.env.REACT_APP_API_URL + "/donor";

const api = getApi(fetchURL);


export const getCampaignDonorsPOST = (data: { campaign_short: string }) =>
  api.post("/retrieveCampaignDonors", data).then((r) => r.data);

export const getDonorLeaderboard = (data: { campaign_id: string }) =>
  api.post("/retrieveLeaderBoard", data).then((r) => r.data);

export const getDonationHistory = (data: { campaign_id: string }) =>
  api.post("/retrieveCampaignDonationHistory", data).then((r) => r.data);

export const getDonationStats = (data: { campaign_id: string, time: string }) =>
  api.post("/donationStats", data).then((r) => r.data);

export const addCampaignDonorPOST = (data: {
  user_id: string;
  campaign_short: string;
  action_type: string;
  action_id: number;
  amount: number;
  note: string;
}) => api.post("/insertDocument", data).then((r) => r.data);
